/**
 * Inline-Validierungsfehler für die Geburtsdatum-Eingabe (DEV-014).
 *
 * Werte korrespondieren direkt zu den i18n-Schlüsseln
 * (`error.dob.required` / `error.dob.future` / `error.dob.tooOld`); die
 * Konsumenten-Komponente baut den i18n-Key über die String-Konstante.
 *
 * `null` (im Konsumer-Hook) bedeutet „aktuell kein Fehler" — entweder ist das
 * Feld leer und wurde nie berührt, oder es enthält ein valides Datum.
 */
export const DobError = {
  Required: 'required',
  Future: 'future',
  TooOld: 'tooOld',
} as const;

export type DobError = (typeof DobError)[keyof typeof DobError];
